import { Box } from "@mui/material";

import Header from "../../components/Header";
//import DataGrid from "devextreme-react/data-grid";

import React, { useEffect, useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import { useDispatch, useSelector } from "react-redux";
import FeedBackList from "../../components/feedBack/feedBackList";
import { getFeedBack, setFilter } from "../../store/reducers/feedBack";
import FilterBox from "../../components/feedBack/filter";

import { getViolationDetectionReportFun } from "../../store/reducers/report";
import ViolationDetectionReportList from "../../components/reports/violation_detection_report/violation_detection_reportt_list";
import VehicleCountBuildList from "../../components/reports/vehicle_count_build_report/vehicle_count_build_report_list";
import VehicleCountMarkList from "../../components/reports/vehicle_count_mark_report/vehicle_count_mark_report_list";
import VehicleCountAgeList from "../../components/reports/vehicle_count_age_report/vehicle_count_age_report_list";

const VehicleCountAgeRepoprt = () => {
  const filter = useSelector((state) => state.report.filter);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isCompanyFilter, setIsCompanyFilter] = useState(false);
  const [compName, setCompanyName] = useState("");
  const dispatch = useDispatch();

  return (
    <Box m="20px">
      <Header
        title="Нийтийн тээврийн автобусны насжилтын судалгаа тайлан"
        subtitle="Нийтийн тээврийн автобусны насжилтын судалгаа /үндсэн. Такси. Буухиа. Хүүхдийн автобус / тайлан"
      />

      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 12" },
        }}
      >
        {/* <Box sx={{ gridColumn: "span 3" }}>
          <FilterBox getFilters={setFilters} />
        </Box> */}
        <Box sx={{ gridColumn: "span 12" }}>
          <VehicleCountAgeList
          //  porkurorReportListData={getViolationDetectionReportData}
          // comptData={compName}
          //  isCompanyFilter={isCompanyFilter}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default VehicleCountAgeRepoprt;
